module.exports = __webpack_public_path__ + "img/cover-ajans-press-courier-ad.8a7f1181.jpg";